<template>
  <loader v-if="loading"/>
  <mortgage-alternatives-page v-else-if="hasMortgageAlternatives" />
  <no-mortgage-data-alternatives-page v-else-if="mortgageFromCashflow" />
  <no-mortgage-page v-else />
</template>

<script>
import Segment from '@/Segment';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loader from '@/base-components/Loader';
import NoMortgagePage from '@/pages/responsive-pages/authenticated/navigation-pages/mortgages/NoMortgagePage.vue';
import MortgageAlternativesPage from './MortgageAlternativesPage.vue';
import NoMortgageDataAlternativesPage from './NoMortgageDataAlternativesPage.vue';

export default {
  name: 'MortgagePage',
  components: {
    NoMortgagePage,
    MortgageAlternativesPage,
    NoMortgageDataAlternativesPage,
    Loader,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState('mortgages', ['mortgageFromCashflow']),
    ...mapGetters('mortgages', ['hasMortgageAlternatives']),
  },
  async created() {
    Segment.trackUserInteraction('MortgagePage_Entered');
    await this.fetchMortgageSimulations();
    this.loading = false;
  },
  methods: {
    ...mapActions('mortgages', ['fetchMortgageSimulations']),
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.cards-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
